import { render, staticRenderFns } from "./expressCountry.vue?vue&type=template&id=22f45350&scoped=true"
import script from "./expressCountry.vue?vue&type=script&lang=js"
export * from "./expressCountry.vue?vue&type=script&lang=js"
import style0 from "./expressCountry.vue?vue&type=style&index=0&id=22f45350&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f45350",
  null
  
)

export default component.exports